var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{staticClass:"co-formulario-opcional-assinatura-whatsapp"},[_c('nome-signatario',{attrs:{"descricao":""},model:{value:(_vm.novoSignatario),callback:function ($$v) {_vm.novoSignatario=$$v},expression:"novoSignatario"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }